import { render, staticRenderFns } from "./Joincarousel.vue?vue&type=template&id=84bd3098&scoped=true"
import script from "./Joincarousel.vue?vue&type=script&lang=js"
export * from "./Joincarousel.vue?vue&type=script&lang=js"
import style0 from "./Joincarousel.vue?vue&type=style&index=0&id=84bd3098&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd3098",
  null
  
)

export default component.exports